(() => {
  const desktop = document.querySelector('.aj-desktop');
  const mobile = document.querySelector('.aj-mobile');
  const content = document.querySelector('[data-aj-content="desktop"]');
  let faqSection = document.querySelector('[data-aj-faq="desktop"]');

  const demoteHeading = (el, tagName) => {
    if (!el || el.tagName.toLowerCase() === tagName) return el;
    const next = document.createElement(tagName);
    Array.from(el.attributes).forEach((attr) => next.setAttribute(attr.name, attr.value));
    while (el.firstChild) next.appendChild(el.firstChild);
    el.replaceWith(next);
    return next;
  };

  // Only one H1 on the page (hero). Body headings in content must be H2+.
  document
    .querySelectorAll('.aj-content h1, .aj-mobile .article-template-content h1, .aj-mobile .rte h1')
    .forEach((h1) => demoteHeading(h1, 'h2'));

  /**
   * Desktop and mobile both render the article (one is CSS-hidden). Demote
   * headings in the inactive layout so they don't duplicate the outline after
   * the article ends at FAQs. Restore them when that layout becomes active.
   */
  const setLayoutHeadingsActive = (root, active) => {
    if (!root) return;

    if (active) {
      root.querySelectorAll('[data-aj-demoted-heading]').forEach((el) => {
        const tag = el.getAttribute('data-aj-demoted-heading') || 'p';
        const restored = document.createElement(tag);
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name === 'data-aj-demoted-heading') return;
          restored.setAttribute(attr.name, attr.value);
        });
        while (el.firstChild) restored.appendChild(el.firstChild);
        el.replaceWith(restored);
      });
      return;
    }

    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((el) => {
      const tag = el.tagName.toLowerCase();
      const next = document.createElement('p');
      Array.from(el.attributes).forEach((attr) => next.setAttribute(attr.name, attr.value));
      next.setAttribute('data-aj-demoted-heading', tag);
      while (el.firstChild) next.appendChild(el.firstChild);
      el.replaceWith(next);
    });
  };

  const syncVisibility = () => {
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (isDesktop) {
      mobile?.setAttribute('aria-hidden', 'true');
      mobile?.setAttribute('inert', '');
      desktop?.removeAttribute('aria-hidden');
      desktop?.removeAttribute('inert');
      setLayoutHeadingsActive(desktop, true);
      setLayoutHeadingsActive(mobile, false);
    } else {
      desktop?.setAttribute('aria-hidden', 'true');
      desktop?.setAttribute('inert', '');
      mobile?.removeAttribute('aria-hidden');
      mobile?.removeAttribute('inert');
      setLayoutHeadingsActive(mobile, true);
      setLayoutHeadingsActive(desktop, false);
    }
  };
  syncVisibility();
  window.matchMedia('(min-width: 990px)').addEventListener('change', syncVisibility);

  const Q_PATTERN = /^Q\s*\d+\s*[:.)-]?\s*(.+)$/i;

  const getQuestionText = (el) => {
    if (!el || el.nodeType !== 1) return null;
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    const match = text.match(Q_PATTERN);
    return match ? match[1].trim() : null;
  };

  const isQuestionNode = (el) => Boolean(getQuestionText(el));

  const createFaqItem = (question, answerHtml, openByDefault) => {
    const details = document.createElement('details');
    details.className = 'aj-faq__item';
    if (openByDefault) details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'aj-faq__question';

    const label = document.createElement('span');
    label.textContent = question;

    const icon = document.createElement('span');
    icon.className = 'aj-faq__icon';
    icon.setAttribute('aria-hidden', 'true');

    summary.appendChild(label);
    summary.appendChild(icon);
    details.appendChild(summary);

    if (answerHtml && answerHtml.trim()) {
      const answer = document.createElement('div');
      answer.className = 'aj-faq__answer rte';
      answer.innerHTML = answerHtml;
      details.appendChild(answer);
    }

    return details;
  };

  /**
   * Move inline "Q1:, Q2:…" pairs from article body into the FAQ accordion.
   */
  const extractFaqsFromRoot = (root) => {
    if (!root) return [];

    const children = Array.from(root.children);
    const pairs = [];
    let index = 0;

    while (index < children.length) {
      const node = children[index];
      const question = getQuestionText(node);

      if (!question) {
        index += 1;
        continue;
      }

      const toRemove = [node];
      const answerParts = [];
      let cursor = index + 1;

      while (cursor < children.length && !isQuestionNode(children[cursor])) {
        answerParts.push(children[cursor].outerHTML);
        toRemove.push(children[cursor]);
        cursor += 1;
      }

      pairs.push({
        question,
        answerHtml: answerParts.join('').trim(),
        nodes: toRemove,
      });
      index = cursor;
    }

    pairs.forEach((pair) => {
      pair.nodes.forEach((node) => node.remove());
    });

    return pairs.map(({ question, answerHtml }) => ({ question, answerHtml }));
  };

  const ensureFaqSection = (scope) => {
    const selector = scope === 'mobile' ? '[data-aj-faq="mobile"]' : '[data-aj-faq="desktop"]';
    let section = document.querySelector(selector);
    if (section) return section;

    if (scope === 'mobile' || !desktop) return null;

    section = document.createElement('div');
    section.className = 'aj-faq';
    section.setAttribute('data-aj-faq', 'desktop');
    section.id = 'frequently-asked-questions';

    const heading = document.createElement('h2');
    heading.className = 'aj-faq__heading heading-bold';
    heading.textContent = 'Frequently Asked Questions';

    const list = document.createElement('div');
    list.className = 'aj-faq__list';
    list.setAttribute('data-aj-faq-list', '');

    section.appendChild(heading);
    section.appendChild(list);

    const author = desktop.querySelector('.aj-author');
    if (author) {
      desktop.insertBefore(section, author);
    } else {
      desktop.appendChild(section);
    }

    return section;
  };

  const fillFaqSection = (section, pairs) => {
    if (!section) return;
    const list = section.querySelector('[data-aj-faq-list]') || section.querySelector('.aj-faq__list');
    if (!list || !pairs.length) {
      if (section && !pairs.length && !list?.children.length) {
        section.hidden = true;
      }
      return;
    }

    list.innerHTML = '';
    pairs.forEach(({ question, answerHtml }, index) => {
      list.appendChild(createFaqItem(question, answerHtml, index === 0));
    });
    section.hidden = false;
    section.removeAttribute('hidden');
  };

  // Strip FAQ heading leftover from content roots after extraction.
  const hideFaqHeadingInRoot = (root) => {
    if (!root) return;
    root.querySelectorAll('h2, h3').forEach((heading) => {
      const t = (heading.textContent || '').trim().toLowerCase();
      if (t === 'faq' || t === 'faqs' || t === 'frequently asked questions') {
        heading.hidden = true;
        heading.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const desktopContent = document.querySelector('[data-aj-content="desktop"]');
  const mobileContent = document.querySelector('[data-aj-content="mobile"]');

  const desktopFaqs = extractFaqsFromRoot(desktopContent);
  const mobileFaqs = extractFaqsFromRoot(mobileContent);
  hideFaqHeadingInRoot(desktopContent);
  hideFaqHeadingInRoot(mobileContent);

  if (desktopFaqs.length) {
    fillFaqSection(ensureFaqSection('desktop'), desktopFaqs);
  } else {
    const desktopFaq = document.querySelector('[data-aj-faq="desktop"]');
    if (desktopFaq) {
      const items = desktopFaq.querySelectorAll('.aj-faq__item');
      items.forEach((item, index) => {
        item.open = index === 0;
      });
      if (!items.length) desktopFaq.hidden = true;
    }
  }

  if (mobileFaqs.length) {
    fillFaqSection(ensureFaqSection('mobile'), mobileFaqs);
  } else if (desktopFaqs.length) {
    // Fallback: reuse desktop-extracted FAQs for the mobile accordion.
    fillFaqSection(ensureFaqSection('mobile'), desktopFaqs);
  } else {
    const mobileFaq = document.querySelector('[data-aj-faq="mobile"]');
    if (mobileFaq && !mobileFaq.querySelectorAll('.aj-faq__item').length) {
      mobileFaq.hidden = true;
    }
  }

  faqSection = document.querySelector('[data-aj-faq="desktop"]');

  document.querySelectorAll('.aj-mobile h2[id], .aj-mobile h3[id], .aj-mobile h4[id]').forEach((el) => {
    el.removeAttribute('id');
  });

  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80);

  const isFaqHeading = (text) => {
    const t = (text || '').trim().toLowerCase();
    return t === 'faq' || t === 'faqs' || t === 'frequently asked questions';
  };

  const getScrollOffset = () => {
    const sticky =
      document.querySelector('.section-header.shopify-section-header-sticky') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.section-header');
    const stickyHeight = sticky ? sticky.getBoundingClientRect().height : 0;
    return Math.max(stickyHeight, 0) + 24;
  };

  const scrollToId = (id) => {
    const live = id && document.getElementById(id);
    if (!live) return;
    const offset = getScrollOffset();
    live.style.scrollMarginTop = `${offset}px`;
    const top = live.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  // Headings get document-wide unique ids, shared across desktop + mobile TOCs.
  const usedIds = new Set();
  const ensureId = (heading, preferred) => {
    const base = slugify(preferred || heading.textContent || 'section') || 'section';
    let unique = heading.id && String(heading.id).startsWith('aj-') ? heading.id : `aj-${base}`;
    let n = 2;
    while (usedIds.has(unique) || (document.getElementById(unique) && document.getElementById(unique) !== heading)) {
      unique = `aj-${base}-${n}`;
      n += 1;
    }
    usedIds.add(unique);
    heading.id = unique;
    heading.classList.add('aj-content__heading');
    return unique;
  };

  /**
   * Builds one TOC (desktop or mobile) from its own content root. Each
   * layout's headings are only "real" (not demoted to <p>) while that
   * layout is active, so the inactive layout's TOC naturally ends up empty
   * and hides itself.
   */
  const setupToc = (tocRoot, contentRoot, { faqAware } = {}) => {
    if (!tocRoot || !contentRoot) return;

    const list = tocRoot.querySelector('[data-aj-toc-list]');
    const panel = tocRoot.querySelector('[data-aj-toc-panel]');
    const toggle = tocRoot.querySelector('[data-aj-toc-toggle]');
    const actionText = tocRoot.querySelector('[data-aj-toc-action-text]');
    const openLabel = (toggle?.getAttribute('data-open-label') || 'VIEW CONTENTS').trim();
    const closeLabel = (toggle?.getAttribute('data-close-label') || 'HIDE CONTENTS').trim();

    const closePanel = () => {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
      if (actionText) actionText.textContent = openLabel;
      tocRoot.classList.remove('is-open');
    };

    const addTocItem = (target, label) => {
      const id = target.id;
      const li = document.createElement('li');
      li.className = 'aj-toc__item';
      const a = document.createElement('a');
      a.className = 'aj-toc__link';
      a.href = `#${id}`;
      a.textContent = label;
      a.addEventListener('click', (event) => {
        event.preventDefault();
        closePanel();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToId(id);
            history.replaceState(null, '', `#${id}`);
          });
        });
      });
      li.appendChild(a);
      list?.appendChild(li);
    };

    let contentFaqHeading = null;
    // TOC lists H2 only — H3/H4 stay in the article body for hierarchy.
    contentRoot.querySelectorAll('h2, h3, h4').forEach((heading) => {
      const raw = heading.textContent.trim();
      if (isFaqHeading(raw)) {
        contentFaqHeading = heading;
        return;
      }
      ensureId(heading, raw);
      if (heading.tagName.toLowerCase() === 'h2') {
        addTocItem(heading, raw);
      }
    });

    if (faqAware) {
      const faqSectionEl =
        document.querySelector(`[data-aj-faq="${faqAware}"]`) ||
        document.querySelector('[data-aj-faq="desktop"]');

      // Theme FAQ section owns FAQs — hide leftover FAQ heading in article body.
      if (faqSectionEl && contentFaqHeading) {
        contentFaqHeading.hidden = true;
        contentFaqHeading.setAttribute('aria-hidden', 'true');
      }

      // One TOC entry: "Frequently Asked Questions" (never "FAQs")
      if (faqSectionEl && !faqSectionEl.hidden) {
        ensureId(faqSectionEl, faqAware === 'mobile' ? 'frequently-asked-questions-mobile' : 'frequently-asked-questions');
        addTocItem(faqSectionEl, 'Frequently Asked Questions');
      } else if (contentFaqHeading) {
        ensureId(contentFaqHeading, 'frequently-asked-questions');
        addTocItem(contentFaqHeading, 'Frequently Asked Questions');
      }
    } else if (contentFaqHeading) {
      // No accordion for this layout — link straight to the inline heading.
      ensureId(contentFaqHeading, 'frequently-asked-questions');
      addTocItem(contentFaqHeading, 'Frequently Asked Questions');
    }

    if (!list?.children.length) {
      tocRoot.hidden = true;
      return;
    }

    if (toggle && panel && actionText) {
      toggle.addEventListener('click', () => {
        const open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        actionText.textContent = open ? closeLabel : openLabel;
        tocRoot.classList.toggle('is-open', open);
      });
    }
  };

  setupToc(document.querySelector('[data-aj-toc="desktop"]'), document.querySelector('[data-aj-content="desktop"]'), {
    faqAware: 'desktop',
  });
  setupToc(document.querySelector('[data-aj-toc="mobile"]'), document.querySelector('[data-aj-content="mobile"]'), {
    faqAware: 'mobile',
  });

  if (window.location.hash) {
    const hashId = window.location.hash.slice(1);
    if (hashId) requestAnimationFrame(() => scrollToId(hashId));
  }
})();
